var _rect, _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConcrete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 183,
    height: 51,
    viewBox: "0 0 183 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 183,
    height: 51,
    rx: 8,
    fill: "#F4D037"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_25044_67670",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 28,
    y: 18,
    width: 128,
    height: 16
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M155.375 18H28V33.2084H155.375V18Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_25044_67670)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M155.376 18.0002V28.3834H155.042V18.3337H154.548V18.2966H139.496V18.0002H155.376Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.496 18.0002H123.614V18.2966H139.496V18.0002Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.497 19.7372H139.163V28.383H139.497V19.7372Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.615 18.0002H107.735V18.2966H123.615V18.0002Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.614 19.7372H123.28V28.383H123.614V19.7372Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.736 18.0002H91.8564V18.2966H107.736V18.0002Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.735 19.7372H107.401V28.383H107.735V19.7372Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.8552 18.0002H75.9736V18.2966H91.8552V18.0002Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.8559 19.7372H91.5225V28.383H91.8559V19.7372Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.9742 18.0002H60.0947V18.2966H75.9742V18.0002Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.9741 19.7372H75.6406V28.383H75.9741V19.7372Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.0944 18.0002H44.2148V18.2966H60.0944V18.0002Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.0952 19.7372H59.7617V28.383H60.0952V19.7372Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.215 18V18.2964H28.7719V18.3335H28.3335V28.3832H28V18H44.215Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.2143 19.7372H43.8809V28.383H44.2143V19.7372Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.5535 33.0469C38.1612 33.0469 39.489 32.3634 39.8904 30.8628L38.8446 30.5149C38.5626 31.573 37.6383 32.0032 36.6461 32.0032C34.9705 32.0032 34.2191 31.011 34.2191 29.4424V27.003C34.2191 25.5559 34.9293 24.4422 36.5514 24.4422C37.449 24.4422 38.4679 24.8169 38.8426 25.9841L39.8883 25.6362C39.4334 24.2158 38.2806 23.3986 36.6708 23.3986C34.4456 23.3986 33.1055 24.8725 33.1055 26.8301V29.6318C33.1055 31.5894 34.3262 33.0489 36.5494 33.0489L36.5535 33.0469Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.2208 23.5456C50.1149 23.5456 48.8428 25.0463 48.8428 26.9895V29.752C48.8428 31.6953 50.1149 33.196 52.2208 33.196C54.3267 33.196 55.5968 31.6953 55.5968 29.752V26.9895C55.5968 25.0463 54.3246 23.5456 52.2208 23.5456ZM54.4852 29.6182C54.4852 31.2115 53.6268 32.1502 52.2208 32.1502C50.8148 32.1502 49.9544 31.2115 49.9544 29.6182V27.1233C49.9544 25.53 50.8128 24.5913 52.2208 24.5913C53.6288 24.5913 54.4852 25.53 54.4852 27.1233V29.6182Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.8637 25.7815L70.4871 33.0605H71.5596V23.6777H70.448V31.0226L65.8225 23.6777H64.75V33.0605H65.8637V25.7815Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.2127 33.1939C85.8204 33.1939 87.1481 32.5105 87.5495 31.0098L86.5038 30.6619C86.2218 31.72 85.2975 32.1502 84.3053 32.1502C82.6297 32.1502 81.8783 31.158 81.8783 29.5894V27.1501C81.8783 25.7029 82.5885 24.5893 84.2106 24.5893C85.1081 24.5893 86.1271 24.9639 86.5018 26.1311L87.5475 25.7832C87.0925 24.3628 85.9398 23.5456 84.33 23.5456C82.1047 23.5456 80.7646 25.0195 80.7646 26.9772V29.7788C80.7646 31.7365 81.9853 33.196 84.2086 33.196L84.2127 33.1939Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.516 29.7092C103.56 29.2275 104.151 28.2209 104.151 27.0414V26.6811C104.151 24.9911 102.93 23.6777 100.933 23.6777H97.5283V33.0605H98.642V30.0448H100.933C101.094 30.0448 101.254 30.0303 101.402 30.018L103.253 33.0605H104.593L102.516 29.7092ZM101.001 29.0134H98.642V24.6555H101.001C102.261 24.6555 103.037 25.4748 103.037 26.7882V26.8808C103.037 28.1941 102.261 29.0134 101.001 29.0134Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.059 32.0148H113.951V28.892H118.521V27.8462H113.951V24.7235H118.925V23.6777H112.84V33.0605H119.059V32.0148Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.165 24.873H135.181V23.8273H128.023V24.873H131.052V33.21H132.165V24.873Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.562 33.0605H150.782V32.0148H145.675V28.892H150.245V27.8462H145.675V24.7235H150.647V23.6777H144.562V33.0605Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConcrete);
export default __webpack_public_path__ + "static/media/concrete.09f2bc17b0dd3170df9bd542cf29d4f8.svg";
export { ForwardRef as ReactComponent };